module.exports = __webpack_public_path__ + "static/Agroscope-851ffc2f550585d1e971d30b41ff35b5.png";